import {inject, Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';

// Deliberately minimal: this is an internal admin tool, so all it has to do is
// give screen readers a page-change announcement per route (WCAG 2.4.2).
// homey-app's TitleStrategy is an SEO strategy - canonical URLs, meta
// descriptions, JSON-LD, robots tags - none of which applies here.
@Injectable({providedIn: 'root'})
export class AdminV2TitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    this.title.setTitle(this.buildTitle(snapshot) ?? 'Homey Admin');
  }
}
